<!-- Sticky horizontal scrollbar strip for the schedule board. The HOST
     (position: sticky; bottom: 0) pins to the scroll container's bottom edge
     while the board's own horizontal scrollbar is off-screen. The TRACK is
     the real scroll engine (native overflow semantics + keyboard arrows);
     the absolute thumb overlay is the visual affordance + drag handle. -->
<div
    #track
    class="sticky-scrollbar-track"
    [style.left.px]="trackLeftPx"
    [style.width.px]="trackWidthPx"
    [attr.tabindex]="hostVisible ? '0' : null"
    [attr.role]="'scrollbar'"
    [attr.aria-orientation]="'horizontal'"
    [attr.aria-label]="'Horizontal scroll for the schedule board'"
    [attr.aria-valuemin]="0"
    [attr.aria-valuenow]="ariaValueNow"
    [attr.aria-valuemax]="ariaValueMax"
    (scroll)="onTrackScroll()"
    (wheel)="onWheel($event)"
    (click)="onTrackClick($event)"
>
    <div
        class="sticky-scrollbar-space"
        [style.width.px]="contentWidth"
    ></div>
</div>
<div
    class="sticky-scrollbar-thumb-housing"
    [style.left.px]="trackLeftPx"
    [style.width.px]="trackWidthPx"
>
    <div
        #thumb
        class="sticky-scrollbar-thumb"
        [style.width.%]="thumbWidthPct"
        [style.left.%]="thumbLeftPct"
        (pointerdown)="onThumbPointerDown($event)"
    ></div>
</div>